import React from 'react';
import SkuLine from './SkuLine';
import { Props } from './types';
import { LightTableContainer } from 'components/common';

const SkusSelector = (props: Props) => {
  const {
    skus = [],
    setSkus,
    additionalProps
  } = props;

  return (
    <LightTableContainer title='Stock Keeping Units'>

      {skus.map((sku, index) =>
        <SkuLine
          key={index}
          sku={sku}
          setSkuProp={value => {
            const cloneSkus = [...skus];
            cloneSkus[index] = { ...cloneSkus[index], ...value };
            setSkus(cloneSkus);
          }}
          additionalProps={additionalProps}
        />
      )}

    </LightTableContainer>
  );
};

export default SkusSelector;
